// extracted by mini-css-extract-plugin
export default {"content":"FlashCardList_content__2jlQ3","list-format":"FlashCardList_list-format__m6K-0"};